export default class DataAttributeHelper {
  static fromObject = (dataObject) => {
    if (!dataObject) return {};

    return Object.fromEntries(
      Object.entries(dataObject).map(([dataKey, dataValue]) => [
        `data-${dataKey}`,
        dataValue,
      ])
    );
  };
}
